/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireSIBDQ {
  position: number;
  question: string;
  answers: string[];
}

export const Q_SIBDQ: QuestionnaireSIBDQ[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Quanto spesso, durante le ultime 2 settimane, ha avuto problemi di stanchezza o di affaticamento? La preghiamo di indicare quanto spesso, durante le ultime 2 settimane, è stato un problema per lei la sensazione di stanchezza o di affaticamento, scegliendo una delle seguenti risposte:',
    answers: [
      '1 - Sempre',
      '2 - Quasi sempre',
      '3 - Spesso',
      '4 - Qualche volta',
      '5 - Raramente',
      '6 - Quasi mai',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 2, question: 'Quanto spesso, durante le ultime 2 settimane, ha dovuto rimandare, o rinunciare a un incontro con amici o parenti, a causa dei suoi problemi intestinali? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Sempre',
      '2 - Quasi sempre',
      '3 - Spesso',
      '4 - Qualche volta',
      '5 - Raramente',
      '6 - Quasi mai',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Quanta difficoltà ha avuto durante le ultime 2 settimane a svolgere le attività sportive e di svago che avrebbe voluto, a causa dei suoi problemi intestinali? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Grandissima difficoltà; impossibile svolgere qualsiasi attività',
      '2 - Molta difficoltà',
      '3 - Abbastanza difficoltà',
      '4 - Una certa difficoltà',
      '5 - Poca difficoltà',
      '6 - Quasi nessuna difficoltà',
      '7 - Nessuna difficoltà; i problemi intestinali non hanno limitato le attività sportive o di svago'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Quanto spesso, durante le ultime 2 settimane, ha avuto dolori addominali (alla pancia)? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Sempre',
      '2 - Quasi sempre',
      '3 - Spesso',
      '4 - Qualche volta',
      '5 - Raramente',
      '6 - Quasi mai',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 5, question: 'Quanto spesso, durante le ultime 2 settimane, si è sentito/a depresso/a o scoraggiato/a? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Sempre',
      '2 - Quasi sempre',
      '3 - Spesso',
      '4 - Qualche volta',
      '5 - Raramente',
      '6 - Quasi mai',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 6, question: 'Nel complesso, in che misura è stato un problema per lei fare molta aria, durante le ultime 2 settimane? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Grossissimo problema',
      '2 - Grosso problema',
      '3 - Problema rilevante',
      '4 - Un certo problema',
      '5 - Leggero problema',
      '6 - Quasi nessun problema',
      '7 - Nessun problema'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 7, question: 'Nel complesso, in che misura è stato un problema per lei riuscire a mantenere o a raggiungere il peso desiderato, durante le ultime 2 settimane? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Grossissimo problema',
      '2 - Grosso problema',
      '3 - Problema rilevante',
      '4 - Un certo problema',
      '5 - Leggero problema',
      '6 - Quasi nessun problema',
      '7 - Nessun problema'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 8, question: 'Quanto spesso, durante le ultime 2 settimane, si è sentito/a rilassato/a e disteso/a? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Mai',
      '2 - Quasi mai',
      '3 - Raramente',
      '4 - Qualche volta',
      '5 - Spesso',
      '6 - Quasi sempre',
      '7 - Sempre',
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 9, question: 'Quanto spesso, durante le ultime 2 settimane, ha avuto lo stimolo ad andare in bagno anche se poi non le usciva niente? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Sempre',
      '2 - Quasi sempre',
      '3 - Spesso',
      '4 - Qualche volta',
      '5 - Raramente',
      '6 - Quasi mai',
      '7 - Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 10, question: 'Quanto spesso durante le ultime 2 settimane ha provato rabbia a causa dei problemi intestinali? La preghiamo di scegliere una delle seguenti risposte:',
    answers: [
      '1 - Sempre',
      '2 - Quasi sempre',
      '3 - Spesso',
      '4 - Qualche volta',
      '5 - Raramente',
      '6 - Quasi mai',
      '7 - Mai'
    ]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class SIBDQResults {
  patientSSN: string;
  doctorID: string;
  results: string[];

  constructor(doctorID: string, patientSSN: string, results: string[]) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
  }

}
